import { useState } from "react";
import { useApp } from "@/App";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

export default function PriceList() {
  const { packages } = useApp();
  const [activeCategory, setActiveCategory] = useState("udrzba");

  const categories = [
    { key: "udrzba", label: "Údržbové programy" },
  ];

  const filtered = packages.filter(p => p.category === activeCategory);

  const scrollToBooking = () => {
    const el = document.querySelector("#booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="pricing" className="py-24 md:py-32 bg-[#030303]" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#39FF14] mb-4">
            Ceník
          </p>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight uppercase">
            Transparentní <span className="text-[#39FF14]">ceny</span>
          </h2>
          <p className="text-base text-zinc-500 mt-4 max-w-xl">
            Žádné skryté poplatky. Ceny jsou konečné a platí pro osobní vozidla.
            Pro SUV a dodávky kontaktujte naši pobočku.
          </p>
        </motion.div>

        {/* Category tabs */}
        <div className="flex flex-wrap gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat.key}
              onClick={() => setActiveCategory(cat.key)}
              className={`px-5 py-2 text-xs font-bold uppercase tracking-wider transition-colors duration-300 ${
                activeCategory === cat.key
                  ? "bg-[#39FF14] text-black"
                  : "border border-white/10 text-zinc-400 hover:border-white/20 hover:text-white"
              }`}
              data-testid={`price-cat-${cat.key}`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Price cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((pkg, index) => (
            <motion.div
              key={pkg.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`border p-8 relative ${
                pkg.popular
                  ? "border-[#39FF14]/50 bg-[#0C0C0C]"
                  : "border-white/10 bg-[#0A0A0A]"
              }`}
              data-testid={`price-card-${pkg.id}`}
            >
              {pkg.popular && (
                <div className="absolute -top-px left-0 right-0 h-[2px] bg-[#39FF14]" />
              )}

              <div className="mb-6">
                <h3 className="text-xl font-bold uppercase tracking-wide">{pkg.name}</h3>
                <p className="text-xs text-zinc-500 mt-1 uppercase tracking-wider">{pkg.duration}</p>
              </div>

              <div className="mb-8">
                {pkg.price > 0 ? (
                  <>
                    <span className="text-4xl font-black">{pkg.price.toLocaleString()}</span>
                    <span className="text-zinc-500 ml-2">Kč</span>
                  </>
                ) : (
                  <span className="text-2xl font-bold text-[#39FF14]">Na konzultaci</span>
                )}
              </div>

              <ul className="space-y-3 mb-8">
                {pkg.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-zinc-300">
                    <Check className="w-4 h-4 text-[#39FF14] mt-0.5 flex-shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>

              <button
                onClick={scrollToBooking}
                className={`w-full btn-skew py-3 text-xs font-bold uppercase tracking-wider transition-colors duration-300 ${
                  pkg.popular
                    ? "bg-[#39FF14] text-black hover:bg-white"
                    : "border border-white/20 text-white hover:border-[#39FF14] hover:text-[#39FF14]"
                }`}
                data-testid={`price-book-${pkg.id}`}
              >
                <span>Objednat</span>
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
